import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import * as pkg from 'react-lazy-load-image-component';
const { LazyLoadImage } = pkg;
import { PriceConvert } from '../../../../../../UI/Price/Price';
import Swiper from '../../../../../../Swiper/Swiper';
import { SwiperSlide } from 'swiper/react';
import { AppContext } from '../../../../../../../contexts/AppContext';

const ReviewStars = ({ numOfStars }) => {
  const getStarIcon = (index) => {
    if (numOfStars >= index + 1) return 'star-full';
    if (numOfStars > index && numOfStars < index + 1) return 'star-half';
    return 'star-empty';
  };

  return Array.from({ length: 5 }, (_, index) => (
    <i key={index} className={`icon ${getStarIcon(index)}`}>
      <span className='sr-only'>Rated {numOfStars} out of 5 stars</span>
    </i>
  ));
};

function Slide({
  title,
  product,
  zone,
  zoneName,
  removeRecentlyViewedProduct,
  cmsp = null,
  showProductTitle,
  showProductPrice,
  showProductRating,
  siteFormat,
  sku,
}) {
  const qv =
    product.productName.toLowerCase().indexOf('chanel') === -1 &&
    product.productName.toLowerCase().indexOf('egift') === -1;

  const onClick = () => window.Peerius?.smartRecsClick(product.recInteractionData);
  const onClickRemove = () => removeRecentlyViewedProduct(product.productCatentryId);
  const handleLazyLoadImg = () => {
    try {
      window.zonos?.displayCurrency();
    } catch (e) {}
  };

  const isDesktop = siteFormat === 'desktop';
  showProductTitle = showProductTitle === 'true' || showProductTitle === true;
  showProductPrice = showProductPrice === 'true' || showProductPrice === true;
  showProductRating = showProductRating === 'true' || showProductRating === true;

  const showProductInfo = showProductTitle || showProductPrice || showProductRating;
  const categoryId = zone ? zone : zoneName ? zoneName : '';

  return (
    <figure className='item' key={product.productCatentryId}>
      <div className='image-wrap'>
        <Link
          to={{
            pathname: product.productUrl,
            search: sku ? `?sku=${sku}` : '',
            state: {
              categoryId,
              qv,
            },
          }}
          onClick={onClick}
          manual_cm_sp={cmsp}
          className='item-img'
        >
          <LazyLoadImage
            onLoad={handleLazyLoadImg}
            src={product.productImg}
            alt={product.productName.split('&trade;').join('™')}
            width='100%'
            height='100%'
          />
        </Link>
        {title === 'Recently Viewed' && (
          <button onClick={onClickRemove} className='rv-remove' type='button' aria-label='remove'>
            <svg
              className='closeSVG'
              height={isDesktop ? '11' : '8'}
              width={isDesktop ? '11' : '8'}
              viewBox='0 0 16 16'
              role='img'
              aria-labelledby={'removeRVItem-' + product.productCatentryId}
            >
              <title id={'removeRVItem-' + product.productCatentryId}>
                Remove {product.productName.split('&trade;').join('™')} from recently viewed list
              </title>
              <path
                d='M15.6,15.6c-0.5,0.5-1.4,0.5-1.9,0L8,9.9l-5.7,5.7c-0.5,0.5-1.4,0.5-1.9,0c-0.5-0.5-0.5-1.4,0-1.9L6.1,8L0.4,2.3
                              c-0.5-0.5-0.5-1.4,0-1.9C0.7,0.1,1,0,1.3,0s0.7,0.1,1,0.4L8,6.1l5.7-5.7c0.5-0.5,1.4-0.5,1.9,0C15.9,0.7,16,1,16,1.3s-0.1,0.7-0.4,1
                              L9.9,8l5.7,5.7C16.1,14.2,16.1,15.1,15.6,15.6z'
              />
            </svg>
          </button>
        )}
      </div>
      {showProductInfo && (
        <>
          {showProductTitle && product.productBrandName && (
            <Link
              to={{
                pathname: product.productUrl,
                state: {
                  categoryId,
                  qv,
                },
              }}
              onClick={onClick}
              manual_cm_sp={cmsp}
              className='item-title'
            >
              {product.productBrandName.split('#double;').join('"').split('&quot;').join('"')}
            </Link>
          )}
          {showProductPrice && product.offerPriceMin && product.offerPriceMax && (
            <Link
              to={{
                pathname: product.productUrl,
                state: {
                  categoryId,
                  qv,
                },
              }}
              onClick={onClick}
              manual_cm_sp={cmsp}
              className={product.onSpecial > 0 ? 'item-title text-danger' : 'item-title'}
            >
              {product.onSpecial && product.offerPriceMin && product.offerPriceMax ? (
                <>
                  {product.onSpecial === 0 ? (
                    <PriceConvert priceOne={product.offerPriceMin} priceTwo={product.offerPriceMax} />
                  ) : (
                    <>
                      Now <PriceConvert priceOne={product.offerPriceMin} priceTwo={product.offerPriceMax} />
                    </>
                  )}
                </>
              ) : (
                ''
              )}
            </Link>
          )}
          {showProductRating && product.rating && (
            <Link
              to={{
                pathname: product.productUrl,
                state: {
                  categoryId,
                  qv,
                },
              }}
              onClick={onClick}
              manual_cm_sp={cmsp}
              className='item-title d-flex justify-content-center align-items-center'
            >
              <ReviewStars numOfStars={product.rating} />
              <span className='reviewCount'>({product.reviewCount})</span>
            </Link>
          )}
        </>
      )}
    </figure>
  );
}

const useOnSlideChange = () => {
  return React.useCallback(() => {
    const lazyImages = document.querySelectorAll('.productRecs');
    if (lazyImages) {
      Array.from(lazyImages).forEach((lazyImage) => {
        const images = lazyImage.querySelectorAll('img');
        Array.from(images).forEach((img) => {
          if (img.dataset.original) {
            img.src = img.dataset.original;
          }
        });
      });
    }
  }, []);
};

// Extract a function to determine sliders per view based on app format and zone
const getSlidersPerView = (passedAppFunctions, productsPerRow, zone, widgetData) => {
  switch (passedAppFunctions.siteFormat) {
    case 'tablet':
      switch (zone) {
        case 'BrandSuperCatPopular':
        case 'WishlistCarousel':
          return 3.6;
        case 'JFYZ1':
          return 4.6;
        default:
          return 4.6;
      }
    case 'mobile':
      return 2.51;
    default:
      // If left or right content is present, use products per row, otherwise use calculated value
      return widgetData?.displayOptions?.leftContent || widgetData?.displayOptions?.rightContent
        ? productsPerRow
        : productsPerRow;
  }
};

// Define a hook for getting settings based on site format and other props
const useSettings = ({ siteFormat, productsPerRow, scrollable, rows, products, getSlidersPerView }) => {
  let slidesPerView;

  switch (siteFormat) {
    case 'tablet':
      slidesPerView = getSlidersPerView;
      break;
    case 'mobile':
      slidesPerView = productsPerRow === 1 ? 1 : getSlidersPerView;
      break;
    default:
      slidesPerView = productsPerRow;
  }

  const commonSettings = {
    pagination: false,
    loop: false,
    direction: 'horizontal',
    speed: 500,
    slidesPerGroup: siteFormat === 'mobile' && productsPerRow !== 1 ? 2 : 1,
    allowTouchMove: true,
    grid: rows > 1 ? { rows } : false,
    navigation: false,
  };

  switch (siteFormat) {
    case 'tablet':
      return { ...commonSettings, slidesPerView, spaceBetween: false };
    case 'mobile':
      return {
        ...commonSettings,
        slidesPerView,
        allowTouchMove: scrollable,
      };
    default:
      return {
        ...commonSettings,
        slidesPerView,
        allowTouchMove: scrollable,
        navigation: scrollable && products.length > productsPerRow,
      };
  }
};

export const ProductCarousel = ({
  productsPerRow,
  scrollable,
  rows,
  products = [],
  title = '',
  zone,
  zoneName,
  removeRecentlyViewedProduct,
  showProductPrice,
  showProductRating,
  showProductTitle,
  cmsp,
  contentData,
}) => {
  const onSlideChange = useOnSlideChange();

  const { passedAppFunctions } = useContext(AppContext);

  const getSlidersPerViewValue = getSlidersPerView(passedAppFunctions, productsPerRow, zone, contentData?.widgetData);
  const settings = useSettings({
    siteFormat: passedAppFunctions.siteFormat,
    productsPerRow,
    scrollable,
    rows,
    products,
    getSlidersPerView: getSlidersPerViewValue,
  });

  // Early return if no products
  if (!products.length) return null;

  // Generate carousel tile class name from title
  const carouselTile = (title ?? '').trim().replace(/\s+/g, '-').toLowerCase();

  return (
    <div
      className={`productRecs ${
        settings.navigation ? 'has-arrows' : ''
      } ${contentData?.parentFile === 'TopCategoriesDisplay' ? 'splashProdRecs' : ''} col-sm-12`}
      role='region'
      aria-label='suggestion carousel'
    >
      <div id='product-carousel' className={carouselTile}>
        {carouselTile && (
          <h2 className='pr-title-wrapper'>
            <span className='pr-title'>{title.trim()}</span>
          </h2>
        )}
        <Swiper onSlideChange={onSlideChange} {...settings}>
          {(products || []).map((product, index) => {
            if (!(contentData && contentData.productId && contentData.productId == product.productCatentryId)) {
              return (
                <SwiperSlide key={index}>
                  <Slide
                    key={index}
                    siteFormat={passedAppFunctions.siteFormat}
                    title={title}
                    zone={zone}
                    zoneName={zoneName}
                    removeRecentlyViewedProduct={removeRecentlyViewedProduct}
                    product={product}
                    showProductPrice={showProductPrice}
                    showProductRating={showProductRating}
                    showProductTitle={showProductTitle}
                    cmsp={cmsp}
                    sku={product.sku}
                  />
                </SwiperSlide>
              );
            }
          })}
        </Swiper>
      </div>
    </div>
  );
};
export default ProductCarousel;
